<template>
  <modal
    v-slot="{ data }"
    name="single-sign-on-modal"
    modal-style="compact"
    :display-header-title="false"
  >
    <single-sign-on :session-expired="data.sessionExpired" />
  </modal>
</template>


<script>
  import SingleSignOn from './single-sign-on/index.vue';


  export default {
    name: 'SingleSignOnModal',

    components: {
      SingleSignOn
    }
  };
</script>
